var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createTrackingBundleUrl } from './utils/create-tracking-bundle-url.util';
var TrackingWrapper = (function () {
    function TrackingWrapper(_a) {
        var trackingBundleBaseUrl = _a.trackingBundleBaseUrl, trackingBundleParameters = _a.trackingBundleParameters, _b = _a.logTrackingEventsInConsole, logTrackingEventsInConsole = _b === void 0 ? true : _b, _c = _a.disableTracking, disableTracking = _c === void 0 ? false : _c;
        this.trackingBeingInitialisedPromise = undefined;
        this.trackingBundleBaseUrl = trackingBundleBaseUrl;
        this.trackingBundleParameters = trackingBundleParameters;
        this.logTrackingEventsInConsole = logTrackingEventsInConsole;
        this.disableTracking = disableTracking;
    }
    TrackingWrapper.prototype.isTrackingInitialised = function () {
        var _a;
        return !!window.IS24 && !!((_a = window.IS24.TEALIUM) === null || _a === void 0 ? void 0 : _a.tracking);
    };
    TrackingWrapper.prototype.isTrackingDisabled = function () {
        return this.disableTracking;
    };
    TrackingWrapper.prototype.isLoggingTrackingEventsInConsoleEnabled = function () {
        return this.logTrackingEventsInConsole && !this.disableTracking;
    };
    TrackingWrapper.prototype.initTrackingFramework = function () {
        if (this.isTrackingInitialised() && this.trackingBeingInitialisedPromise === undefined) {
            return Promise.resolve();
        }
        if (this.isTrackingInitialised() && this.trackingBeingInitialisedPromise !== undefined) {
            this.trackingBeingInitialisedPromise = undefined;
            return Promise.resolve();
        }
        if (this.trackingBeingInitialisedPromise === undefined) {
            var trackingBundleUrl_1 = createTrackingBundleUrl(this.trackingBundleBaseUrl, this.trackingBundleParameters);
            this.trackingBeingInitialisedPromise = new Promise(function (resolve) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.id = 'tealium-script';
                script.src = trackingBundleUrl_1;
                script.async = true;
                script.onload = function () { return resolve(); };
                document.body.appendChild(script);
            });
        }
        return this.trackingBeingInitialisedPromise;
    };
    TrackingWrapper.prototype.trackEvent = function (trackingEvent, trackingOptions) {
        var _a, _b, _c, _d;
        if (trackingOptions) {
            (_b = (_a = window.IS24) === null || _a === void 0 ? void 0 : _a.TEALIUM) === null || _b === void 0 ? void 0 : _b.tracking.report(trackingEvent, trackingOptions);
        }
        else {
            (_d = (_c = window.IS24) === null || _c === void 0 ? void 0 : _c.TEALIUM) === null || _d === void 0 ? void 0 : _d.tracking.report(trackingEvent);
        }
    };
    TrackingWrapper.prototype.trackingDebugLogger = function (trackingEvent, trackingOptions) {
        if (trackingOptions) {
            console.table({ trackingEvent: trackingEvent, trackingOptions: trackingOptions });
        }
        else {
            console.table({ trackingEvent: trackingEvent });
        }
    };
    TrackingWrapper.prototype.report = function (trackingEvent, trackingOptions) {
        var _this = this;
        if (this.isLoggingTrackingEventsInConsoleEnabled()) {
            this.trackingDebugLogger(trackingEvent, trackingOptions);
        }
        if (this.isTrackingDisabled()) {
            return Promise.resolve();
        }
        return (function () { return __awaiter(_this, void 0, void 0, function () {
            var _1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!!this.isTrackingInitialised()) return [3, 2];
                        return [4, this.initTrackingFramework()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.trackEvent(trackingEvent, trackingOptions);
                        return [3, 4];
                    case 3:
                        _1 = _a.sent();
                        this.disableTracking = true;
                        return [2, Promise.resolve()];
                    case 4: return [2];
                }
            });
        }); })();
    };
    return TrackingWrapper;
}());
export { TrackingWrapper };
